import PropTypes from 'prop-types';
import React from 'react';
import pageSpacingConfig from './config';
import StyledSpacingWrapper from './styled-spacing-wrapper';

const propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	dataTestId: PropTypes.string,
	marginBottom: PropTypes.oneOf(Object.keys(pageSpacingConfig)),
};

const defaultProps = {
	children: undefined,
	className: undefined,
	dataTestId: 'fuse-spacing-wrapper-test-id',
	marginBottom: 'l',
};

function SpacingWrapper({ children, className, dataTestId, marginBottom, ...props }) {
	return (
		<StyledSpacingWrapper
			className={className}
			data-testid={dataTestId || 'fuse-spacing-wrapper-test-id'}
			marginBottom={marginBottom}
			{...props}
		>
			{children}
		</StyledSpacingWrapper>
	);
}

SpacingWrapper.propTypes = propTypes;
SpacingWrapper.defaultProps = defaultProps;

export { SpacingWrapper };

export default SpacingWrapper;
